import i18next from 'i18next';
import { set } from 'lodash-es';
import { initReactI18next } from 'react-i18next';
import * as resources from 'src/translations';

export const MissingKeys = {};

i18next.use(initReactI18next).init({
  lng: 'en',
  fallbackLng: 'en',
  defaultNS: 'translation',
  fallbackNS: 'translation',
  resources,
  react: {
    transKeepBasicHtmlNodesFor: ['br', 'strong', 'i', 'p', 'b'],
  },
  saveMissing: false,
  missingKeyHandler: (lngs, namespace, key, res) => {
    const exists = i18next.exists(`${namespace}:${key}`, { lng: 'en' }); // So it wouldn't cause missingKey loop
    set(
      MissingKeys,
      `${i18next.language}.${namespace}.${key}`,
      exists ? i18next.t(`${namespace}:${key}`, { lng: 'en' }) : '',
    );
  },
  interpolation: {
    escape: text => text,
  },
});

export const handleLanguageHotReload = () => {
  const isProd = window.config.REACT_APP_ENV !== 'development';

  if (module.hot && !isProd) {
    module.hot.accept('../translations', () => {
      Object.keys(resources).forEach(lang => {
        //@ts-ignore
        Object.keys(resources[lang]).forEach(namespace => {
          //@ts-ignore
          i18next.addResourceBundle(lang, namespace, resources[lang][namespace], true, true);
        });
      });

      // Get current language, reset it in order to reload translations with the new values.
      const currentLang = i18next.language;
      i18next.changeLanguage(currentLang).then(() => i18next.emit('loaded'));
    });
  }
};

export default i18next;
